import * as React from "react";
import { connect } from "react-redux";
import SearchInput, { createFilter } from "react-search-input";
import OldIcon from "@eave/shared/components/OldIcon";
import { AppSearchData } from "@eave/shared/types/api";
import { featureFlag } from "config";
import browserHistory from "web_modules/redux/history";
import { Toggle } from "carbon-components-react";

import { updateSearchTerm } from "web_modules/redux/searchLoans/actions";

import {
  appToBorrower1Name,
  appToBorrower2Name,
  appToBorrower3Name,
  appToBorrower4Name,
} from "../shared";
import Money from "../../Money";

const titleize = require("underscore.string/titleize");
const humanize = require("underscore.string/humanize");

const styles = require("./styles.module.scss");

const KEYS_TO_FILTERS = ["loanid", "name", "email", "address", "loan_status", "loan_decision"];

interface HomepageProps {
  apps: AppSearchData[];
  searchTerm: string;
  dispatch?: Function;
}

class Homepage extends React.Component<HomepageProps, any> {
  static redirectToApp(appId: number) {
    browserHistory.push(`/underwriter/app/${appId}`);
  }

  static renderAddress(app) {
    const line1 = app.purchased_property_address_line1;
    const line2 = app.purchased_property_address_line2;
    const city = app.purchased_property_city;
    const state = app.purchased_property_state;
    const zip = app.purchased_property_postal_code;

    let addressLine1 = `${titleize(line1)}`;
    if (line2) {
      addressLine1 = `${addressLine1}, ${titleize(line2)}`;
    }
    let addressLine2 = "";
    if (city && state && zip) {
      addressLine2 = `${titleize(city)}, ${state} ${zip}`;
    }

    if (addressLine1 && addressLine2) {
      return (
        <span>
          {addressLine1}
          <br />
          {addressLine2}
        </span>
      );
    }
    return <span className="recent-apps__emdash">—</span>;
  }

  constructor(props: HomepageProps) {
    super(props);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.state = {
      showAll: false,
    };

    // TODO AYC: tests feature flag in staging
    if (featureFlag("sofrConforming")) {
      console.log("sofr conforming feature flag");
    }
    if (featureFlag("sofrJumbo")) {
      console.log("sofr jumbo feature flag");
    }
  }

  searchUpdated(term) {
    const { dispatch } = this.props;
    dispatch(updateSearchTerm(term));
  }

  renderRow(app) {
    const {
      id,
      external_id,
      selected_loan_amount,
      borrower_estimated_loan_amount,
      lead_number,
      closing_date,
      is_archived,
    } = app;

    return (
      <tr key={id} className="recent-apps__row" onClick={Homepage.redirectToApp.bind(this, id)}>
        <td>
          {external_id}
          <br />
          {lead_number}
        </td>
        <td className={styles.nowrap}>
          {appToBorrower1Name(app) || <span className="recent-apps__emdash">—</span>}
          <br />
          {appToBorrower2Name(app) || <span className="recent-apps__emdash">—</span>}
          <br />
          {appToBorrower3Name(app) || <span className="recent-apps__emdash">—</span>}
          <br />
          {appToBorrower4Name(app) || <span className="recent-apps__emdash">—</span>}
        </td>
        <td className={styles.truncate}>
          {app.borrower1_email}
          <br />
          {app.borrower2_email}
          <br />
          {app.borrower3_email}
          <br />
          {app.borrower4_email}
        </td>
        <td>{Homepage.renderAddress(app)}</td>
        <td>
          {humanize(app.loan_status)}
          <br />
          {humanize(app.loan_decision)}
        </td>
        <td>
          <Money value={selected_loan_amount || borrower_estimated_loan_amount || 0} />
        </td>
        <td>{closing_date}</td>
        <td>{is_archived ? "Yes" : "No"}</td>
      </tr>
    );
  }

  render() {
    const { apps, searchTerm } = this.props;
    const { showAll } = this.state;

    const filteredApps = apps.filter(
      createFilter(searchTerm.replace(/[^0-9a-z:]/gi, " "), KEYS_TO_FILTERS),
    );

    return (
      <div className="underwriter-dashboard__children">
        <div className="underwriter-dashboard__children-container">
          <div className={styles.searchBar}>
            <div className={styles.search}>
              <SearchInput
                className={styles["search-input"]}
                onChange={this.searchUpdated}
                fuzzy
                caseSensitive={false}
                sortResults
                value={searchTerm}
                placeholder="Search by names, email, loan number, and address."
              />
              <OldIcon
                type="close"
                size={24}
                className={styles.iconClose}
                onClick={() => this.searchUpdated("")}
              />
              <OldIcon type="search" size={24} className={styles.iconSearch} />
            </div>

            <div className={styles.toggleWrapper}>
              <Toggle
                id="show-archive"
                labelText="Show archived docs?"
                onToggle={() => this.setState({ showAll: !showAll })}
                toggled={showAll}
                labelA=""
                labelB=""
                size="sm"
              />
            </div>
          </div>
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Borrower(s)</th>
                <th>Email</th>
                <th>Property</th>
                <th>Status & Decision</th>
                <th>Loan amount</th>
                <th style={{ width: "120px" }}>COE date</th>
                <th>Archived</th>
              </tr>
            </thead>
            <tbody>
              {filteredApps
                .filter(app => showAll || !app.is_archived)
                .map(app => this.renderRow(app))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const searchTerm = state.operatorHomepage && state.operatorHomepage.homepageSearchTerm;

  const apps = state.operatorHomepage && state.operatorHomepage.searchData;

  return {
    apps,
    searchTerm,
  };
};

export default connect<any, any, any>(mapStateToProps)(Homepage);
